<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Power Dialer" class="d-icon d-icon--power-dialer" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.891 2.636 5.716 5.5l1.335.12a.65.65 0 0 1 .58.768L7.22 8.563l3.208-2.9L9.09 5.61a.65.65 0 0 1-.614-.77l.414-2.204Zm.1-1.438c.462-.417 1.19-.009 1.075.603l-.531 2.826 1.788.07a.65.65 0 0 1 .41 1.131l-4.616 4.176c-.462.418-1.19.009-1.074-.604l.534-2.818-1.748-.156a.65.65 0 0 1-.378-1.13l4.54-4.098Z" fill="currentColor"/><path d="M.502 2.968a.5.5 0 0 0 0 1h3.585a.5.5 0 1 0 0-1H.502ZM.5 5.5a.5.5 0 1 0 0 1h2.087a.5.5 0 0 0 0-1H.5Zm0 2.532a.5.5 0 1 0 0 1h4.045a.5.5 0 1 0 0-1H.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconPowerDialer',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
